import BaseModel from "../../../../base/baseModel";

import DuplicatasNfeModel from "./duplicatas/duplicatasNfeModel";
import FaturamentoNfeModel from "./faturamento/faturamentoNfeModel";

export default class CobrancaNfeModel extends BaseModel {
    faturamento: FaturamentoNfeModel = new FaturamentoNfeModel();
    duplicatas: Array<DuplicatasNfeModel> = new Array<DuplicatasNfeModel>();
}
